import { transformConstants } from '../helpers';

const paymentConfigurationConstants = transformConstants(['MOKAPOS_PAYMENT_CONFIGURATION_SAVE']);

export { paymentConfigurationConstants };
